import { useQuery } from '@tanstack/react-query';
import { getFnolEligiblePolicies } from '../../../../api/claims/fnol.api';
import type { FnolEligiblePolicy } from './fnol.types';

export const FNOL_ELIGIBLE_POLICIES_KEY = [
  'fnol',
  'eligible-policies',
] as const;

/**
 * Policies the signed-in policyholder can report a claim on online. `enabled` lets a caller skip
 * the request entirely for a non-insured persona. Set on the hook call, not the query-key factory,
 * which drops `retry`/`enabled` (see reference: query-key-factory strips options).
 */
export const useFnolEligiblePolicies = (enabled: boolean) =>
  useQuery<FnolEligiblePolicy[]>({
    queryKey: FNOL_ELIGIBLE_POLICIES_KEY,
    queryFn: () => getFnolEligiblePolicies().then((response) => response.data),
    enabled,
    retry: false,
    staleTime: 60_000,
  });
